import React, {Component} from 'react';
import {Button} from 'antd';
import GroupModalSelectForm from './GroupModalSelectForm'

class StationButtonGroupUpdate extends Component {
  state = {
    visible: false
  };
  showModal = () => {
    this.setState({visible: true});
  };
  handleCancel = () => {
    this.setState({visible: false});
  };
  handleUpdate = () => {
    const {station, onUpdate} = this.props
    const form = this.form;
    form.validateFields((err, values) => {
      if (err) {
        return;
      }
      const {GroupID, GroupName} = values
      const updateStation = {
        ...station,
        GroupID: GroupID,
        GroupName: GroupName
      }
      onUpdate(updateStation)
      form.resetFields();
      this.setState({visible: false});
    });
  };
  saveFormRef = (form) => {
    this.form = form;
  };

  render() {
    const {station, groups, treeGroups} = this.props
    const selectedGroup = {
      ID: station.GroupID
    }
    return (<span>
      <Button onClick={this.showModal} type="primary" ghost="ghost" size="small">Địa bàn</Button>
      <GroupModalSelectForm title="Cài đặt địa bàn" group={selectedGroup} groups={groups} treeGroups={treeGroups} ref={this.saveFormRef} visible={this.state.visible} onCancel={this.handleCancel} onSubmit={this.handleUpdate}/>
    </span>);
  }
}

export default StationButtonGroupUpdate;



// WEBPACK FOOTER //
// ./src/components/StationButtonGroupUpdate.js